export default "__VITE_ASSET__BgJmF41M__"